"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _TroubleTicket = _interopRequireDefault(require("../model/TroubleTicket"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Troubleticket service.
* @module api/TroubleticketApi
* @version 3.0
*/
var TroubleticketApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new TroubleticketApi. 
  * @alias module:api/TroubleticketApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TroubleticketApi(apiClient) {
    _classCallCheck(this, TroubleticketApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create a new Trouble Ticket
   * Creates a new Trouble Ticket against the Customer
   * @param {Number} customerId Customer Id
   * @param {module:model/TroubleTicket} troubleTicket Ticket Details
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TroubleTicket} and HTTP response
   */
  return _createClass(TroubleticketApi, [{
    key: "createTroubleTicketWithHttpInfo",
    value: function createTroubleTicketWithHttpInfo(customerId, troubleTicket) {
      var postBody = troubleTicket;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling createTroubleTicket");
      }
      // verify the required parameter 'troubleTicket' is set
      if (troubleTicket === undefined || troubleTicket === null) {
        throw new Error("Missing the required parameter 'troubleTicket' when calling createTroubleTicket");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _TroubleTicket["default"];
      return this.apiClient.callApi('/customers/{customerId}/troubletickets', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Trouble Ticket
     * Creates a new Trouble Ticket against the Customer
     * @param {Number} customerId Customer Id
     * @param {module:model/TroubleTicket} troubleTicket Ticket Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TroubleTicket}
     */
  }, {
    key: "createTroubleTicket",
    value: function createTroubleTicket(customerId, troubleTicket) {
      return this.createTroubleTicketWithHttpInfo(customerId, troubleTicket).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a Trouble Ticket by Id
     * Gets a specific Trouble Ticket details using the ID of the required Trouble Ticket.
     * @param {Number} troubleTicketId ID of the Troubleticket
     * @param {Number} customerId ID of the Customer
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TroubleTicket} and HTTP response
     */
  }, {
    key: "getTroubleTicketByIdWithHttpInfo",
    value: function getTroubleTicketByIdWithHttpInfo(troubleTicketId, customerId) {
      var postBody = null;
      // verify the required parameter 'troubleTicketId' is set
      if (troubleTicketId === undefined || troubleTicketId === null) {
        throw new Error("Missing the required parameter 'troubleTicketId' when calling getTroubleTicketById");
      }
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getTroubleTicketById");
      }
      var pathParams = {
        'troubleTicketId': troubleTicketId,
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _TroubleTicket["default"];
      return this.apiClient.callApi('/customers/{customerId}/troubletickets/{troubleTicketId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a Trouble Ticket by Id
     * Gets a specific Trouble Ticket details using the ID of the required Trouble Ticket.
     * @param {Number} troubleTicketId ID of the Troubleticket
     * @param {Number} customerId ID of the Customer
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TroubleTicket}
     */
  }, {
    key: "getTroubleTicketById",
    value: function getTroubleTicketById(troubleTicketId, customerId) {
      return this.getTroubleTicketByIdWithHttpInfo(troubleTicketId, customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get all Trouble Tickets for a Customer
     * Get a list of all Trouble Tickets for a Customer.<br>Trouble Tickets can be used to store messages about the Customers in the SR-SSB, which can be useful for Call Centre Agents when dealing with queries from Customers.<br>
     * @param {Number} customerId Customer Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TroubleTicket>} and HTTP response
     */
  }, {
    key: "getTroubleTicketsByCustomerIdWithHttpInfo",
    value: function getTroubleTicketsByCustomerIdWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getTroubleTicketsByCustomerId");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_TroubleTicket["default"]];
      return this.apiClient.callApi('/customers/{customerId}/troubletickets', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get all Trouble Tickets for a Customer
     * Get a list of all Trouble Tickets for a Customer.<br>Trouble Tickets can be used to store messages about the Customers in the SR-SSB, which can be useful for Call Centre Agents when dealing with queries from Customers.<br>
     * @param {Number} customerId Customer Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TroubleTicket>}
     */
  }, {
    key: "getTroubleTicketsByCustomerId",
    value: function getTroubleTicketsByCustomerId(customerId) {
      return this.getTroubleTicketsByCustomerIdWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modifies a Trouble Ticket
     * Updates the Trouble Ticket to change the message held inside of a specific Trouble Ticket.
     * @param {Number} troubleTicketId TroubleTicket ID that will be updated
     * @param {Number} customerId Customer Id
     * @param {module:model/TroubleTicket} troubleTicket TroubleTicket info that will be used to update
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TroubleTicket} and HTTP response
     */
  }, {
    key: "modifyTroubleTicketWithHttpInfo",
    value: function modifyTroubleTicketWithHttpInfo(troubleTicketId, customerId, troubleTicket) {
      var postBody = troubleTicket;
      // verify the required parameter 'troubleTicketId' is set
      if (troubleTicketId === undefined || troubleTicketId === null) {
        throw new Error("Missing the required parameter 'troubleTicketId' when calling modifyTroubleTicket");
      }
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling modifyTroubleTicket");
      }
      // verify the required parameter 'troubleTicket' is set
      if (troubleTicket === undefined || troubleTicket === null) {
        throw new Error("Missing the required parameter 'troubleTicket' when calling modifyTroubleTicket");
      }
      var pathParams = {
        'troubleTicketId': troubleTicketId,
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _TroubleTicket["default"];
      return this.apiClient.callApi('/customers/{customerId}/troubletickets/{troubleTicketId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modifies a Trouble Ticket
     * Updates the Trouble Ticket to change the message held inside of a specific Trouble Ticket.
     * @param {Number} troubleTicketId TroubleTicket ID that will be updated
     * @param {Number} customerId Customer Id
     * @param {module:model/TroubleTicket} troubleTicket TroubleTicket info that will be used to update
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TroubleTicket}
     */
  }, {
    key: "modifyTroubleTicket",
    value: function modifyTroubleTicket(troubleTicketId, customerId, troubleTicket) {
      return this.modifyTroubleTicketWithHttpInfo(troubleTicketId, customerId, troubleTicket).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();